module.exports = __webpack_public_path__ + "static/media/marshall-homepage-reduced.d73454fc.jpg";